import React from "react"
import { Route } from "react-router-dom"
import TicketShow from "./tickets/TicketShow"
import TicketScan from "./tickets/TicketScan"
import { SimDetail } from "./sim"
import {
  UsersList,
  DetailMarketer,
  ImportMarketer,
  EditDetailMarketer,
} from "./agency"
import { KolList, KolCreate } from "./campaigns/kol"
import { CampaignChart } from "./campaigns/chart"
import { ProductList } from "./campaigns/productlist"
import { CommissionsChart } from "./agency/commissions"
import { ContentChart } from "./contents/chart"

export default [
  <Route exact path="/ticket/:id/view" component={TicketShow} />,
  <Route exact path="/ticket/:id/scan" component={TicketScan} />,
  <Route exact path="/agency/:id/users" component={UsersList} />,
  <Route exact path="/agency/:id/commissions" component={CommissionsChart} />,
  <Route exact path="/agency/:id/users/import" component={ImportMarketer} />,
  <Route exact path="/agency/:id/users/create" component={DetailMarketer} />,
  <Route exact path="/campaigns/:id/users" component={KolList} />,
  <Route exact path="/campaigns/:id/products" component={ProductList} />,
  <Route exact path="/campaigns/:id/chart" component={CampaignChart} />,
  <Route exact path="/campaigns/:id/users/create" component={KolCreate} />,
  <Route exact path="/contents/:id/chart" component={ContentChart} />,
  <Route
    exact
    path="/agency/:id/users/:agencyid"
    component={EditDetailMarketer}
  />,
  <Route exact path="/sim/:id" component={SimDetail} />,
]



// WEBPACK FOOTER //
// ./src/customRoutes.js